module.exports = __webpack_public_path__ + "img/OTA.2fa87eb0.png";